<template>
  <v-container
    fill-height
    fluid
    grid-list-xl>
    <v-layout
      justify-center
      wrap
    >
      <v-flex xs12 md6>
        <user-card :edit="false" :user="user"></user-card>
      </v-flex>
      <v-flex
        xs12
        md6
        v-if="user && hasAnyRole([UserRoles.ADMIN, UserRoles.DIRECTOR, UserRoles.REVISER])"
      >
        <material-card
          color="green"
          :title="$t('Pages.Users.profile_title')"
          :text="$t('Pages.Users.profile_subtitle')"
        >
          <v-form @submit.prevent="save" enctype="multipart/form-data">
            <v-container py-0>
              <v-layout wrap>
                <v-flex xs12 md4 offset-md4 class="text-xs-center">
                  <label>{{$t('Pages.Users.model.avatar')}}</label>
                  <vue-avatar :width="150" :height="150" id="avatar" ref="avatar" :image="user.profile.avatar"></vue-avatar>

                  <v-tooltip top>
                    <v-btn @click="openAvatarDialog" slot="activator" fab dark color="primary">
                      <v-icon dark>camera</v-icon>
                    </v-btn>
                    <span>{{$t('Common.click_to_select_image')}}</span>
                  </v-tooltip>
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                          v-validate="'min:6'"
                          v-model="user.password"
                          :error-messages="errors.first('password')"
                          :label="$t('Core.Fields.password')"
                          type="password"
                          color="indigo"
                          required
                          counter
                          name="password"
                  />
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                          v-validate="'min:6'"
                          v-model="user.password_confirmation"
                          :error-messages="errors.first('password_confirmation')"
                          :label="$t('Core.Fields.confirm_new_password')"
                          type="password"
                          required
                          name="password_confirmation"
                          counter
                  />
                </v-flex>
                <v-flex
                  xs12
                  text-xs-right
                >
                  <v-btn
                    class="mx-0 font-weight-light"
                    color="success"
                    type="submit"
                  >
                    {{$t('Core.Fields.save')}}
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
    import VueAvatar from '../components/core/VueAvatar'
    import Form from '../services/Form'
    import UserCard from './users/UserCard'
export default {
    components: {VueAvatar, UserCard},
    props: {
    },
    data: () => ({
      user: { profile: {}}
    }),
    computed: {

    },
    created () {
      this.user = this.$store.state.app.me;
    },
    methods: {
        openAvatarDialog(){
            this.$refs.avatar.clicked();
        },

        save(){
            let self = this;
            this.$validator.validateAll().then((result) => {
                if (result) {
                    let data = JSON.parse(JSON.stringify(this.user));

                    data['profile'].avatar = null;
                    if(this.$refs.avatar.imageChanged()) {
                        data['profile'].avatar = this.$refs.avatar.getImage();
                    }

                    data['profile'].signature = null;

                    self.repositories.user.updateMe(Form.prepare(data)).then((response) => {
                      self.$toast.info(response.data.message);
                    });

                }
            });
        }
    }
}
</script>
